(function () {
    'use strict';

    angular.module('app.reporting', [
        'ngRoute'
    ]);
})();